export default __webpack_public_path__ + "static/media/Panaah_Login-01.46061034.png";